import { styled } from '@mui/material/styles';
import MuiAccordion, { AccordionProps } from '@mui/material/Accordion';
import MuiAccordionSummary, { AccordionSummaryProps } from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import CustomText from 'components/common/CustomText/CustomText';
import ExportIcon from 'icons/ExportIcon';
import { Box, IconButton } from '@mui/material';
import { colors } from 'styles/colors';
import { hexWithOpacity } from 'common/utils';
import ExcelIcon from 'icons/ExcelIcon';
import PDFIcon from 'icons/PDFIcon';
import RegistriesIcon from 'icons/RegistriesIcon';
import useGlobalStyles from 'styles/globalStyles';

const Accordion = styled((props: AccordionProps) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  padding: 0,
  '&:not(:last-child)': {
    borderBottom: 0,
  },
  '&::before': {
    display: 'none',
  },
}));

const AccordionSummary = styled((props: AccordionSummaryProps) => (
  <MuiAccordionSummary
    expandIcon={<Box sx={{
      width: 25,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    }}>
      <ExportIcon size={14} color={colors.black} />
    </Box>}
    {...props}
  />
))(({ theme }) => ({
  flexDirection: 'row-reverse',
  padding: '0 0 0 8px',
  borderRadius: '10px',

  '&:hover': {
    backgroundColor: hexWithOpacity(colors.black, 0.04),
  },

  /* kill ALL animations and transitions */
  '& .MuiAccordionSummary-expandIconWrapper': {
    transition: 'none',
  },

  '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
    transform: 'none',
  },


  '& .MuiAccordionSummary-content': {
    marginLeft: '5px',
  },

  ...theme.applyStyles('dark', {
    backgroundColor: 'rgba(255, 255, 255, .05)',
  }),
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(0),
}));

export default function ExportAccordion() {
  const globalStyles = useGlobalStyles();

  return (
    <div>
      <Accordion defaultExpanded={false} elevation={0}>
        <AccordionSummary
          aria-controls="panel1d-content"
          id="panel1d-header"
        >
          <CustomText text="Export" color={colors.black} />
        </AccordionSummary>

        <AccordionDetails>

          <IconButton className={globalStyles.popoverButtonContainer}>
            <Box className={globalStyles.popoverIconContainer}>
              <ExcelIcon size={20} />
            </Box>
            <CustomText text="Export to Excel file" ml="5px" color={colors.black} />
          </IconButton>

          <IconButton className={globalStyles.popoverButtonContainer}>
            <Box className={globalStyles.popoverIconContainer}>
              <PDFIcon size={20} />
            </Box>
            <CustomText text="Export to PDF file" ml="5px" color={colors.black} />
          </IconButton>

          <IconButton className={globalStyles.popoverButtonContainer}>
            <Box className={globalStyles.popoverIconContainer}>
              <RegistriesIcon size={15} />
            </Box>
            <CustomText text="Export to Registries" ml="5px" color={colors.black} />
          </IconButton>

        </AccordionDetails>
      </Accordion>
    </div>
  );
}
